// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__PBQmO","inner":"HeaderSimple_inner__nSF2n","logo":"HeaderSimple_logo__uKnTa"};